import React, { useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

const RolesRowActionsMenu = ({
  row,
  labels,
  onEdit,
  onDelete,
  canEdit = true,
  canDelete: canDeletePermission = true,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const lang = useSelector((state) => state.locale.lang);
  const open = Boolean(anchorEl);
  const showEdit = canEdit;
  const showDelete =
    canDeletePermission && !row.systemRole && row.usersCount === 0;

  if (!showEdit && !showDelete) return null;

  const close = () => setAnchorEl(null);

  const handleEdit = () => {
    close();
    onEdit(row);
  };

  const handleDelete = () => {
    close();
    onDelete(row);
  };

  return (
    <div
      className="team-management__row-actions"
      onClick={(event) => event.stopPropagation()}
    >
      <IconButton
        color="inherit"
        size="small"
        aria-label={labels.actions}
        onClick={(event) => {
          event.stopPropagation();
          setAnchorEl(event.currentTarget);
        }}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={close}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: lang === "en" ? "right" : "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: lang === "en" ? "right" : "left",
        }}
        PaperProps={{
          elevation: 3,
          sx: { minWidth: 160, borderRadius: 2 },
        }}
      >
        {showEdit && (
          <MenuItem dense onClick={handleEdit}>
            {labels.edit}
          </MenuItem>
        )}
        {showDelete && (
          <MenuItem
            dense
            onClick={handleDelete}
            sx={{ color: "error.main" }}
          >
            {labels.remove}
          </MenuItem>
        )}
      </Menu>
    </div>
  );
};

RolesRowActionsMenu.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    systemRole: PropTypes.bool,
    usersCount: PropTypes.number,
  }).isRequired,
  labels: PropTypes.shape({
    actions: PropTypes.string.isRequired,
    edit: PropTypes.string.isRequired,
    remove: PropTypes.string.isRequired,
  }).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  canEdit: PropTypes.bool,
  canDelete: PropTypes.bool,
};

export default RolesRowActionsMenu;
